import { render, staticRenderFns } from "./editPaxelRecycleHowTo.vue?vue&type=template&id=64d3b97a&"
import script from "./editPaxelRecycleHowTo.vue?vue&type=script&lang=js&"
export * from "./editPaxelRecycleHowTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports